module.exports = {"hello":"你好","welcome":"欢迎访问我们的网站！","item_count":"你有 {count} 个项目"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/zh.json
// module id = iM+l
// module chunks = 51